"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var app_1 = require("../app");
var getReturnDecision_1 = require("../queries/getReturnDecision");
var crumb_nav_1 = __importDefault(require("../../account-v3/components/crumb_nav"));
var api_1 = require("../api");
var react_query_1 = require("react-query");
var classnames_1 = __importDefault(require("classnames"));
var inline_loader_1 = __importDefault(require("../../account-v3/components/inline_loader"));
exports.default = (function (_a) {
    var basePath = _a.basePath;
    var context = (0, react_1.useContext)(app_1.NewReturnContext);
    var history = (0, react_router_dom_1.useHistory)();
    var _b = __read((0, react_1.useState)([]), 2), offers = _b[0], setOffers = _b[1];
    if (!context) {
        console.debug("No context loaded");
        return null;
    }
    var selectedItems = context.selectedItems, setReturns = context.setReturns, createReturnInput = context.createReturnInput, setCustomerSelectedReturnOffer = context.setCustomerSelectedReturnOffer;
    if (!createReturnInput || selectedItems.length === 0) {
        history.push("".concat(basePath, "/selectItems"));
        return null;
    }
    var _c = (0, react_query_1.useQuery)(app_1.QueryKey.GET_RETURN_DECISION, function () { return (0, api_1.getSublessAPIClient)().request(getReturnDecision_1.GET_RETURNS_DECISION, { input: createReturnInput }); }, {}), returnDecisionData = _c.data, returnDecisionLoading = _c.isLoading;
    (0, react_1.useEffect)(function () {
        if (returnDecisionData === null || returnDecisionData === void 0 ? void 0 : returnDecisionData.account.returnDecision) {
            setReturns(returnDecisionData.account.returnDecision.returns);
            setOffers(returnDecisionData.account.returnDecision.offers.map(function (o) { return Object.assign({ selected: !!o.preferred }, o); }));
        }
    }, [returnDecisionData]);
    console.debug(offers);
    if (!returnDecisionLoading && offers && offers.length === 1) {
        setCustomerSelectedReturnOffer(offers[0]);
        history.push("".concat(basePath, "/review"));
    }
    var selectOffer = function (rt) {
        if (!offers)
            return;
        var off = offers.map(function (o) {
            o.selected = rt === o.returnType;
            return o;
        });
        console.debug('Setting offers from selectOffer');
        setOffers(off);
    };
    var continueToNextStep = function () {
        var offer = offers.find(function (o) { return o.selected; });
        if (offer) {
            setCustomerSelectedReturnOffer(offer);
            history.push("".concat(basePath, "/review"));
        }
    };
    return (react_1.default.createElement("div", { className: 'padding-bottom-3 return-container' },
        react_1.default.createElement(crumb_nav_1.default, { current: 'Returns', backLink: "".concat(basePath, "/reasons") }),
        returnDecisionLoading && (react_1.default.createElement("div", { className: 'margin-top-4' },
            react_1.default.createElement(inline_loader_1.default, { isLoading: returnDecisionLoading }))),
        react_1.default.createElement("div", { className: 'padding-left-4 padding-right-4' }, !returnDecisionLoading && offers.length > 0 && (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: 'padding-top-10 padding-bottom-5 account-header' }, window.returnsApp.copy.returnMethodStepHeader),
            react_1.default.createElement("div", { className: 'font-lighter font-size-small', dangerouslySetInnerHTML: { __html: window.returnsApp.copy.returnMethodStepCopy } }),
            offers.map(function (offer) { return (react_1.default.createElement("div", { className: (0, classnames_1.default)({ 'return-offer-container': true, 'position-relative': true, selected: offer.selected }), onClick: function () { return selectOffer(offer.returnType); }, key: offer.returnType },
                react_1.default.createElement("div", { className: 'return-offer-check-container position-absolute' },
                    react_1.default.createElement("i", { className: 'ss-check' })),
                react_1.default.createElement("h3", { className: 'h5' },
                    offer.returnType === 'returnlessRefundWithOffer' && "Keep the items with a ".concat(offer.discountPercentage, "% Refund"),
                    offer.returnType === 'regular' && "Ship back items with 100% refund"),
                offer.returnType === 'returnlessRefundWithOffer' && (react_1.default.createElement("div", { className: 'font-size-small font-lighter' },
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("i", { className: 'ss-check margin-right-2' }),
                        "Yep, you can keep it and still get $$ back!"),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("i", { className: 'ss-check margin-right-2' }),
                        "Get 15% instant refund.",
                        react_1.default.createElement("br", null),
                        "Refunds may take 3-5 business days to show up on your payment account."))))); }),
            react_1.default.createElement("div", { className: 'checkout-cta-container' },
                react_1.default.createElement("button", { className: (0, classnames_1.default)({ 'button btn-form': true }), type: 'button', onClick: function () { return continueToNextStep(); } }, "Continue")))))));
});
